<p>
  Select indexing operation here. Warning: do not run these operations unless you are really sure it is necessary!
</p>

@if (operationContainer?.operations?.length) {
  <div class="index">
    <app-operation-menus-two-levels
      class="index__operation-buttons"
      [operationContainer]="operationContainer"
      (operationOpened)="onOpenMenu()"
    ></app-operation-menus-two-levels>
  </div>
}
